const isServer = typeof window === 'undefined';
let isomorphicConfig;

if (isServer) {
    const clientConfig = global.__BZ_CONF__?.public;
    const serverConfig = Object.assign({}, { ...global.__BZ_CONF__ });
    delete serverConfig.public;
    isomorphicConfig = { ...clientConfig, ...serverConfig };
} else {
    isomorphicConfig = window.__bz_config;
}

export default isomorphicConfig;
